import { ApiBase } from "~/extensions/api";
import { GetLatestBasicCommand } from "./commands/GetLatestBasicCommand";
import { GetLatestNyukyoCommand } from "./commands/GetLatestNyukyoCommand";
import { GetLatestShinseiCommand } from "./commands/GetLatestShinseiCommand";
export class LatestApi extends ApiBase {
    getLatestBasic(isForceGetLatest = false) {
        let command = new GetLatestBasicCommand(isForceGetLatest);
        return this.request(command);
    }
    getLatestNyukyo(isForceGetLatest = false) {
        let command = new GetLatestNyukyoCommand(isForceGetLatest);
        return this.request(command);
    }
    getLatestShinsei(isForceGetLatest = false) {
        let command = new GetLatestShinseiCommand(isForceGetLatest);
        return this.request(command);
    }
}
